module.exports = __webpack_public_path__ + "static/media/phone_3.afa66925.png";